<template>
   <Spinner v-if="loading" />
  <section class="details" v-else>
  <Review v-if="review" :BootId="Id" :review="review" :email="$store.getters.StateOwner" :name="$store.getters.DetailsState.name" :user="$store.getters.StateOwner.email" @closeReview="cancelReview($event)"/>
    <div class="intro">
        <img :src="$store.getters.DetailsState.logo" width="187" height="187" alt="Bootcamp logo">
        <div class="intro__text">
            <h4>{{$store.getters.DetailsState.name}}</h4>
            <span>
                <svg
                width="30"
                height="30"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15 26.1249L21.1875 19.9374C22.4111 18.7137 23.2444 17.1546 23.5819 15.4572C23.9195 13.7599 23.7462 12.0006 23.0839 10.4018C22.4216 8.80305 21.3001 7.43654 19.8612 6.47511C18.4222 5.51369 16.7306 5.00053 15 5.00053C13.2695 5.00053 11.5778 5.51369 10.1389 6.47511C8.69995 7.43654 7.57844 8.80305 6.91614 10.4018C6.25385 12.0006 6.08052 13.7599 6.41807 15.4572C6.75562 17.1546 7.58888 18.7137 8.8125 19.9374L15 26.1249ZM15 29.6599L7.04501 21.7049C5.47168 20.1316 4.40023 18.127 3.96616 15.9447C3.53209 13.7624 3.75488 11.5004 4.60637 9.44478C5.45786 7.38912 6.8998 5.63212 8.74985 4.39596C10.5999 3.1598 12.775 2.5 15 2.5C17.225 2.5 19.4001 3.1598 21.2502 4.39596C23.1002 5.63212 24.5421 7.38912 25.3936 9.44478C26.2451 11.5004 26.4679 13.7624 26.0338 15.9447C25.5998 18.127 24.5283 20.1316 22.955 21.7049L15 29.6599ZM15 16.2499C15.663 16.2499 16.2989 15.9865 16.7678 15.5177C17.2366 15.0488 17.5 14.4129 17.5 13.7499C17.5 13.0869 17.2366 12.451 16.7678 11.9821C16.2989 11.5133 15.663 11.2499 15 11.2499C14.337 11.2499 13.7011 11.5133 13.2322 11.9821C12.7634 12.451 12.5 13.0869 12.5 13.7499C12.5 14.4129 12.7634 15.0488 13.2322 15.5177C13.7011 15.9865 14.337 16.2499 15 16.2499ZM15 18.7499C13.6739 18.7499 12.4022 18.2231 11.4645 17.2854C10.5268 16.3478 10 15.076 10 13.7499C10 12.4238 10.5268 11.1521 11.4645 10.2144C12.4022 9.27669 13.6739 8.7499 15 8.7499C16.3261 8.7499 17.5979 9.27669 18.5355 10.2144C19.4732 11.1521 20 12.4238 20 13.7499C20 15.076 19.4732 16.3478 18.5355 17.2854C17.5979 18.2231 16.3261 18.7499 15 18.7499Z"
                  fill="#8F3D55"
                />
              </svg>
                {{$store.getters.DetailsState.location}}
            </span>
            <span class="intro__socials">
                <ShareNetwork
                network="linkedin"
               :url="`https://dashboardzero.vercel.app/${$router.currentRoute.value.href}`"
                :title="$store.getters.DetailsState.name"
                :description="$store.getters.DetailsState.location"
                :quote="$store.getters.DetailsState.description"
              >
              <img src="@/assets/svg/linkedin.svg" alt="" />
            </ShareNetwork>
              <ShareNetwork
                network="facebook"
               :url="`https://dashboardzero.vercel.app/${$router.currentRoute.value.href}`"
               :title="$store.getters.DetailsState.name"
               :description="$store.getters.DetailsState.location"
               :quote="$store.getters.DetailsState.description"
              >
                <img src="@/assets/svg/facebook.svg" alt="" />
            </ShareNetwork>
            <ShareNetwork
            network="twitter"
            :url="`https://dashboardzero.vercel.app/${$router.currentRoute.value.href}`"
            :title="$store.getters.DetailsState.name"
            :description="$store.getters.DetailsState.location"
            :quote="$store.getters.DetailsState.description"
          >
          <img src="@/assets/svg/twitter.svg" alt="" />
        </ShareNetwork>
            </span>
        </div>
    </div>

    <div class="desc">
        <div class="desc__intro">
            <h5>Descriptions</h5>
            <div class="desc__review">
                <button @click="review = true">Write a review</button>
                <div class="icon__container">
                    <div class="icon" :class="{icon__active: Math.ceil($store.getters.DetailsState.reviews_avg_rating)>= rate.id}" v-for="rate in rating" :key="rate.id" v-html="rate.icon"></div>
                    <p>
                        {{ stars }} Rating
                    </p>
                </div>
            </div>
        </div>
        <p>
            {{$store.getters.DetailsState.description}}
        </p>
        <a href="#review">
        <span class="review">
            <img src="@/assets/svg/note.svg" height="24" width="24" alt="">
            {{NumberReview}} Reviews
        </span>
        </a>
        <span class="compare" @click="compareMove($store.getters.DetailsState.name,$store.getters.DetailsState.id)">
            <img src="@/assets/svg/compare.svg" alt="">
            Compare with other bootcamps
        </span>
    </div>

    <div class="marquee">
        <div class="marquee__container">
            <div>
                <span style="color: #000000">
                    <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M6.16797 10.7923C6.16797 9.97457 6.49282 9.19031 7.07106 8.61207C7.64929 8.03383 8.43355 7.70898 9.2513 7.70898H27.7513C28.5691 7.70898 29.3533 8.03383 29.9315 8.61207C30.5098 9.19031 30.8346 9.97457 30.8346 10.7923V24.6673H6.16797V10.7923Z" stroke="white" stroke-width="3.08333" stroke-linecap="round" stroke-linejoin="round"/> <path d="M3.08398 29.293H33.9173" stroke="white" stroke-width="3.08333" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                    Programs Available: {{store.getters.DetailsState.lecture_mode}}
                </span>
                <span style="color: #000000">
                    <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M18.5007 3.08398C9.9999 3.08398 3.08398 9.9999 3.08398 18.5007C3.08398 27.0014 9.9999 33.9173 18.5007 33.9173C27.0014 33.9173 33.9173 27.0014 33.9173 18.5007C33.9173 9.9999 27.0014 3.08398 18.5007 3.08398ZM18.5007 30.834C11.7004 30.834 6.16732 25.3009 6.16732 18.5007C6.16732 11.7004 11.7004 6.16732 18.5007 6.16732C25.3009 6.16732 30.834 11.7004 30.834 18.5007C30.834 25.3009 25.3009 30.834 18.5007 30.834Z" fill="white"/> <path d="M20.0423 10.791H16.959V20.041H26.209V16.9577H20.0423V10.791Z" fill="white"/> </svg>
                    Flexible; Self-pace
                </span>
                <span style="color: #000000">
                    <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M25.2223 21.584C25.3457 20.5665 25.4382 19.549 25.4382 18.5007C25.4382 17.4523 25.3457 16.4348 25.2223 15.4173H30.4332C30.6798 16.404 30.834 17.4369 30.834 18.5007C30.834 19.5644 30.6798 20.5973 30.4332 21.584H25.2223ZM22.4936 30.1557C23.4186 28.4444 24.1277 26.5944 24.6211 24.6673H29.169C27.6754 27.2392 25.3057 29.1875 22.4936 30.1557ZM22.1082 21.584H14.8932C14.739 20.5665 14.6465 19.549 14.6465 18.5007C14.6465 17.4523 14.739 16.4194 14.8932 15.4173H22.1082C22.2469 16.4194 22.3548 17.4523 22.3548 18.5007C22.3548 19.549 22.2469 20.5665 22.1082 21.584ZM18.5007 30.7723C17.2211 28.9223 16.1882 26.8719 15.5561 24.6673H21.4452C20.8132 26.8719 19.7802 28.9223 18.5007 30.7723ZM12.334 12.334H7.83232C9.31055 9.75511 11.6785 7.80378 14.4923 6.84565C13.5673 8.5569 12.8736 10.4069 12.334 12.334ZM7.83232 24.6673H12.334C12.8736 26.5944 13.5673 28.4444 14.4923 30.1557C11.6844 29.187 9.31979 27.2384 7.83232 24.6673ZM6.56815 21.584C6.32148 20.5973 6.16732 19.5644 6.16732 18.5007C6.16732 17.4369 6.32148 16.404 6.56815 15.4173H11.779C11.6557 16.4348 11.5632 17.4523 11.5632 18.5007C11.5632 19.549 11.6557 20.5665 11.779 21.584H6.56815ZM18.5007 6.21357C19.7802 8.06357 20.8132 10.1294 21.4452 12.334H15.5561C16.1882 10.1294 17.2211 8.06357 18.5007 6.21357ZM29.169 12.334H24.6211C24.1386 10.4246 23.4241 8.58141 22.4936 6.84565C25.3302 7.8169 27.689 9.77482 29.169 12.334ZM18.5007 3.08398C9.97523 3.08398 3.08398 10.0215 3.08398 18.5007C3.08398 22.5894 4.70824 26.5107 7.59942 29.4019C9.03099 30.8335 10.7305 31.969 12.6009 32.7438C14.4714 33.5186 16.4761 33.9173 18.5007 33.9173C22.5894 33.9173 26.5107 32.2931 29.4019 29.4019C32.2931 26.5107 33.9173 22.5894 33.9173 18.5007C33.9173 16.4761 33.5186 14.4714 32.7438 12.6009C31.969 10.7305 30.8335 9.03099 29.4019 7.59942C27.9703 6.16785 26.2708 5.03227 24.4004 4.25751C22.5299 3.48275 20.5252 3.08398 18.5007 3.08398Z" fill="white"/> </svg>
                    Website: <a :href="store.getters.DetailsState.website" target="_blank" >{{store.getters.DetailsState.website}}</a>
                </span>
                <span style="color: #000">
                    <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M28.6742 7C29.9008 7 31.0772 7.48728 31.9446 8.35463C32.8119 9.22199 33.2992 10.3984 33.2992 11.625V26.425C33.2992 27.6516 32.8119 28.828 31.9446 29.6954C31.0772 30.5627 29.9008 31.05 28.6742 31.05H8.32422C7.09759 31.05 5.92121 30.5627 5.05385 29.6954C4.18649 28.828 3.69922 27.6516 3.69922 26.425V11.625C3.69922 10.3984 4.18649 9.22199 5.05385 8.35463C5.92121 7.48728 7.09759 7 8.32422 7H28.6742ZM31.4492 14.3278L18.9691 21.6723C18.8511 21.7416 18.7192 21.7839 18.583 21.796C18.4467 21.8082 18.3094 21.7899 18.181 21.7426L18.0293 21.6723L5.54922 14.3315V26.425C5.54922 27.161 5.84158 27.8668 6.362 28.3872C6.88241 28.9076 7.58824 29.2 8.32422 29.2H28.6742C29.4102 29.2 30.116 28.9076 30.6364 28.3872C31.1569 27.8668 31.4492 27.161 31.4492 26.425V14.3278ZM28.6742 8.85H8.32422C7.58824 8.85 6.88241 9.14236 6.362 9.66278C5.84158 10.1832 5.54922 10.889 5.54922 11.625V12.1837L18.4992 19.802L31.4492 12.18V11.625C31.4492 10.889 31.1569 10.1832 30.6364 9.66278C30.116 9.14236 29.4102 8.85 28.6742 8.85Z" fill="white"/> </svg>
                    Mail: <a :href="`mailto:${store.getters.DetailsState.email}`" >{{store.getters.DetailsState.email}}</a>
                </span>
                <span style="color: #000000">
                    <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M28.6742 7C29.9008 7 31.0772 7.48728 31.9446 8.35463C32.8119 9.22199 33.2992 10.3984 33.2992 11.625V26.425C33.2992 27.6516 32.8119 28.828 31.9446 29.6954C31.0772 30.5627 29.9008 31.05 28.6742 31.05H8.32422C7.09759 31.05 5.92121 30.5627 5.05385 29.6954C4.18649 28.828 3.69922 27.6516 3.69922 26.425V11.625C3.69922 10.3984 4.18649 9.22199 5.05385 8.35463C5.92121 7.48728 7.09759 7 8.32422 7H28.6742ZM31.4492 14.3278L18.9691 21.6723C18.8511 21.7416 18.7192 21.7839 18.583 21.796C18.4467 21.8082 18.3094 21.7899 18.181 21.7426L18.0293 21.6723L5.54922 14.3315V26.425C5.54922 27.161 5.84158 27.8668 6.362 28.3872C6.88241 28.9076 7.58824 29.2 8.32422 29.2H28.6742C29.4102 29.2 30.116 28.9076 30.6364 28.3872C31.1569 27.8668 31.4492 27.161 31.4492 26.425V14.3278ZM28.6742 8.85H8.32422C7.58824 8.85 6.88241 9.14236 6.362 9.66278C5.84158 10.1832 5.54922 10.889 5.54922 11.625V12.1837L18.4992 19.802L31.4492 12.18V11.625C31.4492 10.889 31.1569 10.1832 30.6364 9.66278C30.116 9.14236 29.4102 8.85 28.6742 8.85Z" fill="white"/> </svg>
                    Phone Number: <a :href="`${store.getters.DetailsState.phone_number}`" >{{store.getters.DetailsState.phone_number}}</a>
                </span>
                <span style="color: #000000">
                    <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M28.6742 7C29.9008 7 31.0772 7.48728 31.9446 8.35463C32.8119 9.22199 33.2992 10.3984 33.2992 11.625V26.425C33.2992 27.6516 32.8119 28.828 31.9446 29.6954C31.0772 30.5627 29.9008 31.05 28.6742 31.05H8.32422C7.09759 31.05 5.92121 30.5627 5.05385 29.6954C4.18649 28.828 3.69922 27.6516 3.69922 26.425V11.625C3.69922 10.3984 4.18649 9.22199 5.05385 8.35463C5.92121 7.48728 7.09759 7 8.32422 7H28.6742ZM31.4492 14.3278L18.9691 21.6723C18.8511 21.7416 18.7192 21.7839 18.583 21.796C18.4467 21.8082 18.3094 21.7899 18.181 21.7426L18.0293 21.6723L5.54922 14.3315V26.425C5.54922 27.161 5.84158 27.8668 6.362 28.3872C6.88241 28.9076 7.58824 29.2 8.32422 29.2H28.6742C29.4102 29.2 30.116 28.9076 30.6364 28.3872C31.1569 27.8668 31.4492 27.161 31.4492 26.425V14.3278ZM28.6742 8.85H8.32422C7.58824 8.85 6.88241 9.14236 6.362 9.66278C5.84158 10.1832 5.54922 10.889 5.54922 11.625V12.1837L18.4992 19.802L31.4492 12.18V11.625C31.4492 10.889 31.1569 10.1832 30.6364 9.66278C30.116 9.14236 29.4102 8.85 28.6742 8.85Z" fill="white"/> </svg>
                    Address: {{store.getters.DetailsState.address}}
                </span>
            </div>
            <div>
                <span style="color: #000000">
                    <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M6.16797 10.7923C6.16797 9.97457 6.49282 9.19031 7.07106 8.61207C7.64929 8.03383 8.43355 7.70898 9.2513 7.70898H27.7513C28.5691 7.70898 29.3533 8.03383 29.9315 8.61207C30.5098 9.19031 30.8346 9.97457 30.8346 10.7923V24.6673H6.16797V10.7923Z" stroke="white" stroke-width="3.08333" stroke-linecap="round" stroke-linejoin="round"/> <path d="M3.08398 29.293H33.9173" stroke="white" stroke-width="3.08333" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                    Programs Available: {{store.getters.DetailsState.lecture_mode}}
                </span>
                <span style="color: #000000">
                    <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M18.5007 3.08398C9.9999 3.08398 3.08398 9.9999 3.08398 18.5007C3.08398 27.0014 9.9999 33.9173 18.5007 33.9173C27.0014 33.9173 33.9173 27.0014 33.9173 18.5007C33.9173 9.9999 27.0014 3.08398 18.5007 3.08398ZM18.5007 30.834C11.7004 30.834 6.16732 25.3009 6.16732 18.5007C6.16732 11.7004 11.7004 6.16732 18.5007 6.16732C25.3009 6.16732 30.834 11.7004 30.834 18.5007C30.834 25.3009 25.3009 30.834 18.5007 30.834Z" fill="white"/> <path d="M20.0423 10.791H16.959V20.041H26.209V16.9577H20.0423V10.791Z" fill="white"/> </svg>
                    Flexible; Self-pace
                </span>
                <span style="color: #000000">
                    <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M25.2223 21.584C25.3457 20.5665 25.4382 19.549 25.4382 18.5007C25.4382 17.4523 25.3457 16.4348 25.2223 15.4173H30.4332C30.6798 16.404 30.834 17.4369 30.834 18.5007C30.834 19.5644 30.6798 20.5973 30.4332 21.584H25.2223ZM22.4936 30.1557C23.4186 28.4444 24.1277 26.5944 24.6211 24.6673H29.169C27.6754 27.2392 25.3057 29.1875 22.4936 30.1557ZM22.1082 21.584H14.8932C14.739 20.5665 14.6465 19.549 14.6465 18.5007C14.6465 17.4523 14.739 16.4194 14.8932 15.4173H22.1082C22.2469 16.4194 22.3548 17.4523 22.3548 18.5007C22.3548 19.549 22.2469 20.5665 22.1082 21.584ZM18.5007 30.7723C17.2211 28.9223 16.1882 26.8719 15.5561 24.6673H21.4452C20.8132 26.8719 19.7802 28.9223 18.5007 30.7723ZM12.334 12.334H7.83232C9.31055 9.75511 11.6785 7.80378 14.4923 6.84565C13.5673 8.5569 12.8736 10.4069 12.334 12.334ZM7.83232 24.6673H12.334C12.8736 26.5944 13.5673 28.4444 14.4923 30.1557C11.6844 29.187 9.31979 27.2384 7.83232 24.6673ZM6.56815 21.584C6.32148 20.5973 6.16732 19.5644 6.16732 18.5007C6.16732 17.4369 6.32148 16.404 6.56815 15.4173H11.779C11.6557 16.4348 11.5632 17.4523 11.5632 18.5007C11.5632 19.549 11.6557 20.5665 11.779 21.584H6.56815ZM18.5007 6.21357C19.7802 8.06357 20.8132 10.1294 21.4452 12.334H15.5561C16.1882 10.1294 17.2211 8.06357 18.5007 6.21357ZM29.169 12.334H24.6211C24.1386 10.4246 23.4241 8.58141 22.4936 6.84565C25.3302 7.8169 27.689 9.77482 29.169 12.334ZM18.5007 3.08398C9.97523 3.08398 3.08398 10.0215 3.08398 18.5007C3.08398 22.5894 4.70824 26.5107 7.59942 29.4019C9.03099 30.8335 10.7305 31.969 12.6009 32.7438C14.4714 33.5186 16.4761 33.9173 18.5007 33.9173C22.5894 33.9173 26.5107 32.2931 29.4019 29.4019C32.2931 26.5107 33.9173 22.5894 33.9173 18.5007C33.9173 16.4761 33.5186 14.4714 32.7438 12.6009C31.969 10.7305 30.8335 9.03099 29.4019 7.59942C27.9703 6.16785 26.2708 5.03227 24.4004 4.25751C22.5299 3.48275 20.5252 3.08398 18.5007 3.08398Z" fill="white"/> </svg>
                    Website: <a :href="store.getters.DetailsState.website" target="_blank">{{store.getters.DetailsState.website}}</a>
                </span>
                <span style="color: #000000">
                    <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M28.6742 7C29.9008 7 31.0772 7.48728 31.9446 8.35463C32.8119 9.22199 33.2992 10.3984 33.2992 11.625V26.425C33.2992 27.6516 32.8119 28.828 31.9446 29.6954C31.0772 30.5627 29.9008 31.05 28.6742 31.05H8.32422C7.09759 31.05 5.92121 30.5627 5.05385 29.6954C4.18649 28.828 3.69922 27.6516 3.69922 26.425V11.625C3.69922 10.3984 4.18649 9.22199 5.05385 8.35463C5.92121 7.48728 7.09759 7 8.32422 7H28.6742ZM31.4492 14.3278L18.9691 21.6723C18.8511 21.7416 18.7192 21.7839 18.583 21.796C18.4467 21.8082 18.3094 21.7899 18.181 21.7426L18.0293 21.6723L5.54922 14.3315V26.425C5.54922 27.161 5.84158 27.8668 6.362 28.3872C6.88241 28.9076 7.58824 29.2 8.32422 29.2H28.6742C29.4102 29.2 30.116 28.9076 30.6364 28.3872C31.1569 27.8668 31.4492 27.161 31.4492 26.425V14.3278ZM28.6742 8.85H8.32422C7.58824 8.85 6.88241 9.14236 6.362 9.66278C5.84158 10.1832 5.54922 10.889 5.54922 11.625V12.1837L18.4992 19.802L31.4492 12.18V11.625C31.4492 10.889 31.1569 10.1832 30.6364 9.66278C30.116 9.14236 29.4102 8.85 28.6742 8.85Z" fill="white"/> </svg>
                    Mail: <a :href="`mailto:${store.getters.DetailsState.email}`" >{{store.getters.DetailsState.email}}</a>
                </span>
                <span style="color: #000000">
                    <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M28.6742 7C29.9008 7 31.0772 7.48728 31.9446 8.35463C32.8119 9.22199 33.2992 10.3984 33.2992 11.625V26.425C33.2992 27.6516 32.8119 28.828 31.9446 29.6954C31.0772 30.5627 29.9008 31.05 28.6742 31.05H8.32422C7.09759 31.05 5.92121 30.5627 5.05385 29.6954C4.18649 28.828 3.69922 27.6516 3.69922 26.425V11.625C3.69922 10.3984 4.18649 9.22199 5.05385 8.35463C5.92121 7.48728 7.09759 7 8.32422 7H28.6742ZM31.4492 14.3278L18.9691 21.6723C18.8511 21.7416 18.7192 21.7839 18.583 21.796C18.4467 21.8082 18.3094 21.7899 18.181 21.7426L18.0293 21.6723L5.54922 14.3315V26.425C5.54922 27.161 5.84158 27.8668 6.362 28.3872C6.88241 28.9076 7.58824 29.2 8.32422 29.2H28.6742C29.4102 29.2 30.116 28.9076 30.6364 28.3872C31.1569 27.8668 31.4492 27.161 31.4492 26.425V14.3278ZM28.6742 8.85H8.32422C7.58824 8.85 6.88241 9.14236 6.362 9.66278C5.84158 10.1832 5.54922 10.889 5.54922 11.625V12.1837L18.4992 19.802L31.4492 12.18V11.625C31.4492 10.889 31.1569 10.1832 30.6364 9.66278C30.116 9.14236 29.4102 8.85 28.6742 8.85Z" fill="white"/> </svg>
                    Phone Number: <a :href="`${store.getters.DetailsState.phone_number}`" >{{store.getters.DetailsState.phone_number}}</a>
                </span>
                <span style="color: #000000">
                    <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M28.6742 7C29.9008 7 31.0772 7.48728 31.9446 8.35463C32.8119 9.22199 33.2992 10.3984 33.2992 11.625V26.425C33.2992 27.6516 32.8119 28.828 31.9446 29.6954C31.0772 30.5627 29.9008 31.05 28.6742 31.05H8.32422C7.09759 31.05 5.92121 30.5627 5.05385 29.6954C4.18649 28.828 3.69922 27.6516 3.69922 26.425V11.625C3.69922 10.3984 4.18649 9.22199 5.05385 8.35463C5.92121 7.48728 7.09759 7 8.32422 7H28.6742ZM31.4492 14.3278L18.9691 21.6723C18.8511 21.7416 18.7192 21.7839 18.583 21.796C18.4467 21.8082 18.3094 21.7899 18.181 21.7426L18.0293 21.6723L5.54922 14.3315V26.425C5.54922 27.161 5.84158 27.8668 6.362 28.3872C6.88241 28.9076 7.58824 29.2 8.32422 29.2H28.6742C29.4102 29.2 30.116 28.9076 30.6364 28.3872C31.1569 27.8668 31.4492 27.161 31.4492 26.425V14.3278ZM28.6742 8.85H8.32422C7.58824 8.85 6.88241 9.14236 6.362 9.66278C5.84158 10.1832 5.54922 10.889 5.54922 11.625V12.1837L18.4992 19.802L31.4492 12.18V11.625C31.4492 10.889 31.1569 10.1832 30.6364 9.66278C30.116 9.14236 29.4102 8.85 28.6742 8.85Z" fill="white"/> </svg>
                    Address: {{store.getters.DetailsState.address}}
                </span>
            </div>
        </div>
    </div>

    <!-- <div class="course">
        <h2>Courses</h2>
        <div class="course__cards">
            <Card v-for="item in info" :key="item.name" :name="item.name" />
            <div class="course__popular">
                <h3>Popular Courses</h3>
                <button v-for="item in courses" :key="item.title">
                    <img src="@/assets/svg/agency.svg" height="14" width="14" alt="" />
                    <span></span>
                    {{item.title}}
                </button>
            </div>
        </div>
    </div> -->

    <!-- <div class="reviews">
        <h2>Reviews</h2>
        <div class="reviews__cards">
            <div class="item" v-for="item in reviews" :key="item.id">
                <h6>
                    "{{item.title}}"
                </h6>
                <h5>
                    {{item.content}}
                </h5>
                <p>-{{item.user}}</p>
            </div>
        </div>
    </div> -->
    
    <Course :review="$store.getters.DetailsState.reviews" :courses="Courses" />
  </section>
</template>

<script setup>
import Spinner from '@/Layout/Spinner.vue';
import {ShareNetwork, VueSocialSharing} from 'vue-social-sharing'
import { onMounted, computed } from "vue";
import {ref} from "@vue/reactivity"
import Card from "@/shared/courses.vue"
import Review from "./Review.vue";
import Course from "./Courses.vue"
import { useRouter, useRoute } from "vue-router";
import { useStore, mapActions, mapGetters } from "vuex";
const store = useStore()
const router = useRoute()
const route = useRouter()
const Id = router.params.id
const totalReview = ref()
const NumberReview = ref()
const Courses = ref()
const loading = ref(true)
onMounted(async () => {
    mapActions(["Course", "GetReviews"])
    await store.dispatch("GetReviews")
    totalReview.value = store.getters.ReviewsState.length
    mapActions(["BootcampDetails", "Login"])
await store.dispatch("BootcampDetails", Id)
await store.dispatch("User")
NumberReview.value = await store.getters.DetailsState.reviews.length
Courses.value = await store.getters.DetailsState.courses
loading.value = false
})
const review = ref(false);
const cancelReview = (item) => {
    review.value = item;
}
const info = ref([
    {
        name: "Design"
    },
    {
        name: "Design"
    },
    {
        name: "Design"
    }
])
const courses = ref([
    {
        title: "UI/UX"
    },
    {
        title: "DevOps"
    },
    {
        title: "Management"
    },
    {
        title: "Programming"
    },
    {
        title: "Blockchain Dev."
    },
    {
        title: "Graphics Design"
    }
])
const reviews = ref([
    {
        id: 1,
        title: "Rigorous and rewarding program that really helps change your career!",
        content: "Attending the Aorthar Design Bootcamp was one of the best decisions I ever made. I knew I wanted to make a career shift into UX, but I didn't want to risk quitting my job to attend a much more expensive full-time bootcamp. Beginex was the perfect part-time solution",
        user: "Adewale Adedamola"
    },
    {
        id: 2,
        title: "Rigorous and rewarding program that really helps change your career!",
        content: "Attending the Aorthar Design Bootcamp was one of the best decisions I ever made. I knew I wanted to make a career shift into UX, but I didn't want to risk quitting my job to attend a much more expensive full-time bootcamp. Beginex was the perfect part-time solution",
        user: "Adewale Adedamola"
    },
    {
        id: 3,
        title: "Rigorous and rewarding program that really helps change your career!",
        content: "Attending the Aorthar Design Bootcamp was one of the best decisions I ever made. I knew I wanted to make a career shift into UX, but I didn't want to risk quitting my job to attend a much more expensive full-time bootcamp. Beginex was the perfect part-time solution",
        user: "Adewale Adedamola"
    }
])
const rating = ref([
    {
        id: 1,
        active: false,
        icon: `<svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M6 0L7.34708 4.1459H11.7063L8.17963 6.7082L9.52671 10.8541L6 8.2918L2.47329 10.8541L3.82037 6.7082L0.293661 4.1459H4.65292L6 0Z" fill="#FFC100"/> </svg>`
    },
    {
        id: 2,
        active: false,
        icon: `<svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M6 0L7.34708 4.1459H11.7063L8.17963 6.7082L9.52671 10.8541L6 8.2918L2.47329 10.8541L3.82037 6.7082L0.293661 4.1459H4.65292L6 0Z" fill="#FFC100"/> </svg>`
    },
    {
        id: 3,
        active: false,
        icon: `<svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M6 0L7.34708 4.1459H11.7063L8.17963 6.7082L9.52671 10.8541L6 8.2918L2.47329 10.8541L3.82037 6.7082L0.293661 4.1459H4.65292L6 0Z" fill="#FFC100"/> </svg>`
    },
    {
        id: 4,
        active: false,
        icon: `<svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M6 0L7.34708 4.1459H11.7063L8.17963 6.7082L9.52671 10.8541L6 8.2918L2.47329 10.8541L3.82037 6.7082L0.293661 4.1459H4.65292L6 0Z" fill="#FFC100"/> </svg>`
    },
    {
        id: 5,
        active: false,
        icon: `<svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M6 0L7.34708 4.1459H11.7063L8.17963 6.7082L9.52671 10.8541L6 8.2918L2.47329 10.8541L3.82037 6.7082L0.293661 4.1459H4.65292L6 0Z" fill="#FFC100"/> </svg>`
    },
])

// save bootcamp name to localstorage and move to compare bootcamp page
const compareMove = (name, Id) => {
    localStorage.setItem("bootname", name)
    localStorage.setItem("number", Id)
    route.push("/bootcampcompare")
}
</script>

<style lang="scss" scoped>
.details {
    position: relative;
    --gap-space: 1.5rem;
    --space-sm: 1rem;
    --top-space: 0.5rem;
    @keyframes infinityScroll {
  100% {
    transform: translateX(-50%);
  }
}
::v-deep .icon {
    display: flex;
    align-items: center;
    gap: 0.3rem;
    svg {
        margin-bottom: 0.3rem;
        cursor: pointer;
        path {
        // fill: #FFC100;
        fill: #C4C4C4;
        }
    }
    &__active {
        svg {
            path {
                fill: #FFC100;
            }
        }
    }
}
.icon {
    &__container {
        @extend %flex-ac-jc;
        gap: 0.3rem;
        p {
            font-family: "Roboto", sans-serif;
            font-style: normal;
            font-weight: 400;
            font-size: Max(1rem, 16px);
            line-height: Max(1.5rem, 24px);
            letter-spacing: -0.0016em;
            color: $black-100;
            margin-bottom: unset;
        }
    }
}
    .intro {
        padding: 1.5rem 7%;
        height: 400px;
        // background: linear-gradient(180deg, rgba(240, 222, 213, 0) 0%, #F0DED5 100%);
        background-color: $white;
        max-height: var(--height);
        height: var(--height);
        @extend %flex-ac;
        gap: var(--gap-space);
        @include respondMax('tablet2x') {
            flex-direction: column;
            height: auto;
        }
        img {
            object-fit: contain;
        }
        &__text {
            h4 {
                font-family: 'Karla', sans-serif;
                font-style: normal;
                font-weight: 700;
                font-size: Max(4.375rem, 20px);
                line-height: 120%;
                letter-spacing: -0.03em;
                color: $secondary-80;
                margin-bottom: unset;
                @include respondMax('tablet2x') {
                    font-size: Max(3.5rem, 20px);
                }
                @include respondMax('mobile3x') {
                    font-size: Max(2rem, 20px);
                }
            }
            span {
                @extend %flex-ac;
                gap: var(--gap-space);
                margin-bottom: var(--space-sm);
                font-family: 'Karla', sans-serif;
                font-style: normal;
                font-weight: 400;
                font-size: Max(1.5rem, 19px);
                line-height: Max(1.813rem, 20px);
                letter-spacing: -0.03em;
                color: $black-50;
            }
        }
        &__socials {
            @extend %flex-ac;
            gap: var(--space-sm);
        }
    }
    .desc {
        padding: 2.5rem 7%;
        &__intro {
            h5 {
                margin-bottom: unset;
                font-family: 'Karla', sans-serif;
                font-style: normal;
                font-weight: 400;
                font-size: Max(1.875rem, 18px);
                line-height: Max(2rem, 20px);
                letter-spacing: -0.02em;
                color: $black-100;
                @extend %sh-0;
            }
            span {
                @extend %flex-ac-jc;
                @extend %sh-0;
                gap: 0.25rem;
                font-family: 'Karla', sans-serif;
                font-style: normal;
                font-weight: 400;
                font-size: Max(1.175rem, 18px);
                line-height: Max(1.5rem, 18px);
                letter-spacing: -0.015em;
                color: $gray-100;
            }
        }
        &__review {
            @extend %flex-ac;
            gap: var(--gap-space);
            margin-top: var(--top-space);
            @include respondMax("mobile2x") {
                flex-direction: column;
                align-items: flex-start;
            }
            button {
                background-color: $secondary-80;
                border-radius: Max(3.5rem, 36px);
                padding: 6.83333px 13.6667px;
                font-family: 'Karla';
                font-style: normal;
                font-weight: 400;
                font-size: Max(1.125rem, 16px);
                line-height: Max(1.25rem, 24px);
                letter-spacing: -0.015em;
                color: $white;
            }
        }
        p {
            font-family: 'Karla', sans-serif;
            font-style: normal;
            font-weight: 400;
            font-size: Max(1.5rem, 20px);
            line-height: Max(1.813rem, 20px);
            letter-spacing: -0.03em;
            color: $gray-100;
            margin: var(--gap-space) 0;
            padding-right: 10%;
            @include respondMax("mobile3x") {
                padding-right: unset;
            }
        }
        & :where(span) {
            // display: block;
            margin-bottom: 0.5rem;
            font-family: 'Karla', sans-serif;
            font-style: normal;
            font-weight: 400;
            font-size: Max(1.175rem, 16px);
            line-height: Max(1.5rem, 18px);
            letter-spacing: -0.015em;
            color: $black;
            @extend %flex-ac;
            gap: 0.5rem;
        }
        .compare {
            font-weight: 700;
            color: $black-50;
        }
    }
    .marquee {
        background: $secondary-80;
        height: Max(3.25rem, 52px);
        width: 100%;
        max-width: 100vw;
        overflow: hidden;
        @extend %flex-ac;
        gap: var(--gap-space);
        &__container {
            flex-shrink: 0;
            gap: var(--gap-space);
            padding-right: var(--gap-space);
            animation: infinityScroll 18s linear 0s infinite forwards;
            // animation-delay: 4s;
            @extend %flex-ac;
            width: max-content;
            max-width: unset;
            overflow: hidden;
            &:hover {
                animation-play-state: paused;
            }
            &>div {
                @extend %flex-ac;
                gap: var(--gap-space);
                max-width: unset;
                span {
                    @extend %flex-ac;
                    gap: var(--gap-space);
                    font-family: 'Karla', sans-serif;
                    font-style: normal;
                    font-weight: 400;
                    font-size: Max(1.175rem, 16px);
                    line-height: Max(1.5rem, 20px);
                    letter-spacing: -0.015em;
                    flex-shrink: 0;
                }
            }
        }
    }
    .course {
        padding: 2rem 7%;
        h2 {
            font-family: 'Karla', sans-serif;
            font-style: normal;
            font-weight: 700;
            font-size: Max(1.875rem, 18px);
            line-height: Max(2rem, 20px);
            letter-spacing: -0.045em;
            color: $black-50;
            margin-bottom: 1rem;
        }
        &__cards {
            @include flex(flex-start, flex-start);
            gap: var(--gap-space);
            flex-wrap: wrap;
            @media screen and (max-width: 1360px) {
                flex-wrap: wrap;
            }
            @include respondMax("tablet3x") {
                justify-content: center;
            }
        }
        &__popular {
            background: rgba(240, 222, 213, 0.4);
            height: 427px;
            max-height: 427px;
            width: Max(18.5rem, 296px);
            padding: 1.5rem;
            // flex-grow: 1;
            // min-width: 296px;
            h3 {
                font-family: 'Karla', sans-serif;
                font-style: normal;
                font-weight: 700;
                font-size: Max(1.125rem, 18px);
                line-height: Max(1.375rem, 22px);
                letter-spacing: 0.085em;
                text-transform: uppercase;
                color: $secondary-80;
            }
            button {
            background: $secondary-40;
            border-radius: 56.4px;
            height: Max(2rem, 40px);
            // width: Max(5.563rem, 89px);
            padding: 6.83333px 13.6667px;
            @extend %flex-ac-jc;
            gap: var(--top-space);
            font-family: "Abel", sans-serif;
            font-style: normal;
            font-weight: 400;
            font-size: Max(0.75rem, 12px);
            line-height: Max(14px, 0.875rem);
            letter-spacing: 0.015em;
            color: $white;
            margin-top: var(--gap-space);
            span {
                height: 7px;
                width: 7px;
                background-color: $white;
                border-radius: 100%;
            }
            }
        }
    }
    .reviews {
        padding: 2rem 7%;
        h2 {
            font-family: 'Karla', sans-serif;
            font-style: normal;
            font-weight: 700;
            font-size: Max(1.875rem, 18px);
            line-height: Max(2rem, 20px);
            letter-spacing: -0.045em;
            color: $black-50;
            margin-bottom: 1rem;
        }
        &__cards {
            @include flex(flex-start, flex-start);
            gap: var(--gap-space);
            @media screen and (max-width: 1360px) {
                flex-wrap: wrap;
            }
            @media screen and (max-width: 969px) {
                justify-content: center;
            }
            .item {
                width: Max(407px, 25.438rem);
                background: rgba(240, 222, 213, 0.4);
                padding: var(--gap-space);
                @include respondMax(mobile3x) {
                    width: 100%;
                }
                h6 {
                    font-family: 'Karla', sans-serif;
                    font-style: normal;
                    font-weight: 400;
                    font-size: Max(1.125rem, 18px);
                    line-height: Max(1.5rem, 24px);
                    letter-spacing: -0.015em;
                    color: $gray-100;
                }
                h5 {
                    font-family: 'Karla', sans-serif;
                    font-style: normal;
                    font-weight: 400;
                    font-size: Max(0.75rem, 12px);
                    line-height: Max(0.75rem, 14px);
                    letter-spacing: 0.015em;
                    color: $black;
                    margin: var(--space-sm) 0;
                }
                p {
                    font-family: 'Karla', sans-serif;
                    font-style: normal;
                    font-weight: 400;
                    font-size: Max(0.75rem, 12px);
                    line-height: Max(0.75rem, 14px);
                    letter-spacing: 0.015em;
                    color: $black;
                    margin: var(--space-sm) 0;
                }
            }
        }
    }
}
</style>